import { useApiClient } from '@skylabs-digital/react-proto-kit';
import { useMemo } from 'react';
import {
  type ActivityEvent,
  activityEventSchema,
  type EventType,
} from '../schemas/activity.schema';
import type { FilesPage } from './files.api';
import { unwrap } from './unwrap';

export interface ActivityPage {
  data: ActivityEvent[];
  meta: FilesPage['meta'];
}

export interface ActivityQuery {
  appId?: string;
  type?: EventType;
  q?: string;
  page: number;
  limit: number;
}

export function useActivityActions() {
  const { connector } = useApiClient();
  // Memoizado sobre el connector: la página cuelga su efecto de `list`.
  return useMemo(
    () => ({
      list: async (q: ActivityQuery): Promise<ActivityPage> => {
        const params = new URLSearchParams({ page: String(q.page), limit: String(q.limit) });
        if (q.appId) params.set('appId', q.appId);
        if (q.type) params.set('type', q.type);
        if (q.q) params.set('q', q.q);
        const res = await connector.get<unknown[]>(`activity?${params}`);
        const data = unwrap(res).map((e) => activityEventSchema.parse(e));
        const meta = (res as { meta?: FilesPage['meta'] }).meta ?? {
          total: data.length,
          page: q.page,
          limit: q.limit,
          totalPages: 1,
          hasNext: false,
          hasPrev: q.page > 1,
        };
        return { data, meta };
      },
    }),
    [connector],
  );
}
